let topthreeservices = [
  {
    id: 1,
    title: "Loans",
    image: "loanservice",
    description: [
      "Home Loans",
      "Business Loans",
      "Personal Loans",
      "Loan Against Property",
      "Loan Against Security",
    ],
  },
  {
    id: 2,
    title: "Insurance",
    image: "insuranceservice",
    description: ["Vehicle Insurance", "Health Insurance"],
  },
  {
    id: 3,
    title: "Investment Banking",
    image: "investmentservice",
    description: [
      "Investment Banking",
      "Start Ups",
      "Fund Raising",
      "Corporate Advisory",
      "Asset Sale",
      "Brand Acquisition",
      "Project Advisory",
    ],
  },
];

export default topthreeservices;
